export interface ADDRESS {
  street_no: string;
  moo_no: string;
  building: string;
  room_no: string;
  floor_no: string;
  village_name: string;
  alley: string;
  lane: string;
  road: string;
  sub_district: string;
  district: string;
  province: string;
  postal_code: string;
  soi: string;
}

export const BKK = ['Bangkok', 'กรุงเทพมหานคร'];

export const synonymAddress = {
  street_no: ['บ้านเลขที่ ', 'บ้านเลขที่', 'เลขที่ ', 'เลขที่'],
  moo_no: ['หมู่ที่ ', 'หมู่ที่', 'หมู่ ', 'หมู่'],
  building: ['อาคาร ', 'อาคาร'],
  room_no: ['ห้องเลขที่ ', 'ห้องเลขที่', 'ห้องที่ ', 'ห้องที่', 'ห้อง ', 'ห้อง'],
  floor_no: ['ชั้นที่ ', 'ชั้นที่', 'ชั้น ', 'ชั้น'],
  village_name: ['หมู่บ้าน', 'หมู่บ้าน', 'มบ ', 'มบ. ', 'มบ.', 'ม.บ. ', 'ม.บ.', 'ม. ', 'ม.'],
  soi: ['ซอย ', 'ซอย', 'ซ. ', 'ซ.', 'ซ '],
  alley: ['ตรอก ', 'ตรอก'],
  lane: ['แยก ', 'แยก'],
  road: ['ถนน ', 'ถนน', 'ถ. ', 'ถ.', 'ถ '],
  district: ['แขวง ', 'แขวง', 'ข ', 'ข. ', 'ข.', 'ตำบล ', 'ตำบล', 'ต ', 'ต. ', 'ต.'],
  amphoe: ['เขต ', 'เขต', 'ข ', 'ข. ', 'ข.', 'อำเภอ ', 'อำเภอ', 'อ ', 'อ. ', 'อ.'],
};

export const synonymAddressForEmployee = { // todo manual fixed for replace synonym employee address
  street_no: ['บ้านเลขที่ ', 'บ้านเลขที่', 'เลขที่ ', 'เลขที่'],
  moo_no: ['หมู่ที่ ', 'หมู่ที่', 'หมู่ ', 'หมู่'],
  building: ['อาคาร ', 'อาคาร'],
  room_no: ['ห้องเลขที่ ', 'ห้องเลขที่', 'ห้องที่ ', 'ห้องที่', 'ห้อง ', 'ห้อง'],
  floor_no: ['ชั้นที่ ', 'ชั้นที่', 'ชั้น ', 'ชั้น'],
  village_name: ['หมู่บ้าน', 'หมู่บ้าน', 'มบ ', 'มบ. ', 'มบ.', 'ม.บ. ', 'ม.บ.', 'ม. ', 'ม.'],
  soi: ['ซอย ', 'ซอย', 'ซ. ', 'ซ.', 'ซ '],
  alley: ['ตรอก ', 'ตรอก'],
  lane: ['แยก ', 'แยก'],
  road: ['ถนน ', 'ถนน', 'ถ. ', 'ถ.', 'ถ '],
  sub_district: ['แขวง ', 'แขวง', 'ข ', 'ข. ', 'ข.', 'ตำบล ', 'ตำบล', 'ต ', 'ต. ', 'ต.'],
  district: ['เขต ', 'เขต', 'ข ', 'ข. ', 'ข.', 'อำเภอ ', 'อำเภอ', 'อ ', 'อ. ', 'อ.'],
};
